module.exports = __webpack_public_path__ + "images/category_lp/common/icon-company-3@2x_589b8920e586a44921b5a08324d51eff.png";